import { AudiencerateTitleIcon, SvgIcon } from '@/lib';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

type DefaultSidebarLogoProps = {
  logoClassName?: string;
  titleClassName?: string;
};

export const DefaultSidebarLogo: FC<DefaultSidebarLogoProps> = ({ logoClassName, titleClassName }) => {
  return (
    <header className='flex items-center gap-4 overflow-hidden ps-1'>
      <SvgIcon name='AudiencerateLogoIcon' className={twMerge('size-8 self-center', logoClassName)} />
      <AudiencerateTitleIcon className={titleClassName} />
    </header>
  );
};
